import { checkoutWidgetsSchema } from "@redotech/redo-model/checkouts/checkout-widgets-builder";
import * as z from "zod/v4";

export const updateGlobalCheckoutWidgetsConfig = {
  name: "updateGlobalCheckoutWidgetsConfig" as const,
  input: z.object({ checkoutWidgets: checkoutWidgetsSchema }),
  output: z.void(),
};
